import * as React from "react";
import {Link} from "react-router-dom"
interface Props {
    avisos: any;
    label: string;
    itemURL: string;
    bc_seconds: number;
}
const HeaderAO: React.FC<Props> = ({avisos, label, itemURL, bc_seconds}) => {
   /*  return (
            <Link 
                 className="row w-100 justify-content-center align-content-center m-0 mb-1 alert-primary" style={{maxWidth:"700px", height: "40px", borderRadius: "10px"}}
            to={{
                pathname: "/avisos",
                state: {
                    avisos
                }
            }}>
                {label} {" >>"}
            </Link>
    ) */

    return (

        <div
        style={{
          marginTop: "8px"
        }}
      >
        <Link
          style={{
            padding: 0,
            borderRadius: "20px"
          }}
          className="list-group-item list-group-item-action flex-column align-items-start"
          style={{
            padding: "0",
            borderWidth: "0"
          }}
          to={{
            pathname: "/avisos",
            state: {
                avisos,
                bc_seconds
            }
        }}
        >
          <div
          className="row ml-1 mr-1"
            style={{
              height: "6.8em",
              borderRadius: "20px",
              justifyContent: "center"
            }}
          >
  
            <div
            className="col-11"
              style={{
                height: "100%",
                borderRadius: "20px 0px 0px 20px",
                backgroundImage: `url(/google-storage/${encodeURIComponent(itemURL)})`,
                backgroundPosition: "center",
                backgroundSize: "cover"
              }}
            >
            </div>
  
            <button className="btn btn-lg btn-danger col-1" 
            style={{
              height: "100%",
              textAlign: "center",
              padding: 0,
              borderRadius: "0px 20px 20px 0px"
            }}>&raquo;</button>
           
          </div>
        </Link>
      </div>
      );
}

export default HeaderAO;
